import React, { ChangeEvent, Dispatch, useEffect, useRef, useState } from 'react'
import { GroupDataRow } from '../../earlyWarning/emailComp/EmailTypes';
import { GenerateEarlyWarningDataRow } from './FloodSimulation';

import loadLightIcon from '../../../images/icons/load-light.gif'
import loadDarkIcon from '../../../images/icons/load-dark.gif'
import { useTheme } from '../../../context/ThemeContext';
import { DownIcon, UpIcon } from '../../iconSet/IconSet';

export type GroupTableType = {
    id: string;
    name: string;
    description: string;
    organization: string;
    department: string;
}

type UserSelectTablePropsType = {
    ewData: GenerateEarlyWarningDataRow[];
    setSelectedEWData: Dispatch<React.SetStateAction<GenerateEarlyWarningDataRow[]>>;
    isLoading: boolean;
}

const rowsData: GenerateEarlyWarningDataRow[] = [
    {
        buildingId: 51040,
        type: "BLDGA",
        owner: "Nihal Perera",
        mobile: "0711111111",
        areaOfRisk: "91780.2011292",
        maxDepth: 200,
        startTime: "05/01/2024, 18:00",
        peakTime: "05/01/2024, 18:00",
    },
    {
        buildingId: 51041,
        type: "BLDGA",
        owner: "Gihan Fernando",
        mobile: "0711111111",
        areaOfRisk: "91780.2011292",
        maxDepth: 200,
        startTime: "05/01/2024, 18:00",
        peakTime: "05/01/2024, 18:00",
    },
];

const FloodSimulationDataTable = (props: UserSelectTablePropsType) => {

    const { theme } = useTheme()
    
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const rowNumber = useRef<HTMLInputElement | null>(null)
    const searchText = useRef<HTMLInputElement | null>(null)

    const [selectedPage, setSelectedPage] = useState<number>(0)
    const [sliceCount, setSliceCount] = useState<number>(10)

    const [slicedData, setSlicedData] = useState<GenerateEarlyWarningDataRow[][]>([])

    const allGroups = useRef<GenerateEarlyWarningDataRow[]>(rowsData);
    const [filteredData, setFilteredData] = useState<GenerateEarlyWarningDataRow[]>(rowsData);

    const [selectedGroups, setSelectedGroups] = useState<GenerateEarlyWarningDataRow[]>([])

    // true = A -> Z
    // false = Z -> A
    const [buildingIdSort, setBuildingIdSort] = useState<Boolean>(true)
    const buildingIdSortHandle = () => {
        setBuildingIdSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const buildingTypeComparison = buildingTypeSort ? a.buildingId - b.buildingId : b.buildingId - a.buildingId
                return buildingTypeComparison
            })
        })
    }, [buildingIdSort])

    const [buildingTypeSort, setBuildingTypeSort] = useState<Boolean>(true)
    const buildingTypeSortHandle = () => {
        setBuildingTypeSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const usernameComparison = buildingTypeSort ? a.type.localeCompare(b.type) : b.type.localeCompare(a.type)
                return usernameComparison
            })
        })
    }, [buildingTypeSort])

    const [ownerSort, setOwnerSort] = useState<Boolean>(true)
    const ownerSortHandle = () => {
        setOwnerSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const ownerComparison = ownerSort ? a.owner.localeCompare(b.owner) : b.owner.localeCompare(a.owner)
                return ownerComparison
            })
        })
    }, [ownerSort])

    const [mobileSort, setMobileSort] = useState<Boolean>(true)
    const mobileSortHandle = () => {
        setMobileSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const mobileComparison = mobileSort ? a.mobile.localeCompare(b.mobile) : b.mobile.localeCompare(a.mobile)
                return mobileComparison
            })
        })
    }, [mobileSort])

    const [riskAreaSort, setRiskAreaSort] = useState<Boolean>(true)
    const riskAreaSortHandle = () => {
        setRiskAreaSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const riskAreaComparison = riskAreaSort ? a.areaOfRisk.localeCompare(b.areaOfRisk) : b.areaOfRisk.localeCompare(a.areaOfRisk)
                return riskAreaComparison
            })
        })
    }, [riskAreaSort])

    const [maxDepthSort, setMaxDepthSort] = useState<Boolean>(true)
    const maxDepthSortHandle = () => {
        setMaxDepthSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const maxDepthComparison = maxDepthSort ? a.maxDepth - b.maxDepth : b.maxDepth - a.maxDepth
                return maxDepthComparison
            })
        })
    }, [maxDepthSort])

    const [startSort, setStartSort] = useState<Boolean>(true)
    const startSortHandle = () => {
        setStartSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const startComparison = startSort ? a.startTime.localeCompare(b.startTime) : b.startTime.localeCompare(a.startTime)
                return startComparison
            })
        })
    }, [startSort])

    const [peakSort, setPeakSort] = useState<Boolean>(true)
    const peakSortHandle = () => {
        setPeakSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const peakComparison = peakSort ? a.peakTime.localeCompare(b.peakTime) : b.peakTime.localeCompare(a.peakTime)
                return peakComparison
            })
        })
    }, [peakSort])

    //const [groups, setGroups] = useState<GroupTableType[]>(allData)

    useEffect(() => {
        if(props.ewData.length > 0){
            setSelectedGroups(props.ewData)
        }
    }, [props.ewData])

    const paginationList = (data: GenerateEarlyWarningDataRow[], size: number): GenerateEarlyWarningDataRow[][] => {
        const result: GenerateEarlyWarningDataRow[][] = []

        if (size >= data.length) {
            return [data]
        }

        let start = 0

        while (start < data.length) {
            result.push(data.slice(start, start + size))
            start += size
        }

        return result
    }

    const paginationNavigation = (side: "next" | "prev") => {
        if (side === "next") {
            if (slicedData.length > selectedPage + 1) {
                setSelectedPage(prevState => prevState + 1)
                console.log(">>>> good next")
            }

        } else if (side === "prev") {
            if (0 <= selectedPage - 1) {
                setSelectedPage(prevState => prevState - 1)
            }
        }
    }

    const handleSliceCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSliceCount(event.target.valueAsNumber)
    }

    const handleSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === '') {
            setFilteredData(rowsData)
        } else {
            const query = event.target.value.toLowerCase();
            setFilteredData(rowsData.filter(item =>
                item.buildingId.toString().toLowerCase().includes(query) ||
                item.type.toLowerCase().includes(query) ||
                item.owner.toLowerCase().includes(query) ||
                item.mobile.toLowerCase().includes(query) ||
                item.areaOfRisk.toLowerCase().includes(query) ||
                item.maxDepth.toString().toLowerCase().includes(query) ||
                item.startTime.toLowerCase().includes(query) ||
                item.peakTime.toLowerCase().includes(query)
            ));
        }
    }

    useEffect(() => {
        const sliced = paginationList(filteredData, sliceCount);
        setSlicedData(sliced);
        setSelectedPage(0);
    }, [filteredData, sliceCount]);

    const handleGroupSelection = (group: GenerateEarlyWarningDataRow, isChecked: boolean) => {
        let updatedSelection = [];

        if (isChecked) {
            updatedSelection = [...selectedGroups, group];
        } else {
            updatedSelection = selectedGroups.filter(
                selected => selected.buildingId !== group.buildingId // Assuming each group has a unique `id`
            );
        }
        console.log(updatedSelection);
        setSelectedGroups(updatedSelection);
        props.setSelectedEWData(updatedSelection); // <-- Call the prop to set selected groups
    }

    const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked

        const currentPageRows = slicedData[selectedPage] || [];

        if (isChecked) 
            {
           
            const updatedSelection = [
                ...selectedGroups,
                ...currentPageRows.filter(
                    row => !selectedGroups.some(selected => selected.buildingId === row.buildingId)
                ),
            ];

            setSelectedGroups(updatedSelection);
            props.setSelectedEWData(updatedSelection);
        } 
        else 
        {
            const updatedSelection = selectedGroups.filter(
                selected => !currentPageRows.some(row => row.buildingId === selected.buildingId)
            );

            setSelectedGroups(updatedSelection);
            props.setSelectedEWData(updatedSelection);
        }
    }

    return (
        <div className='subTable-wrapper'>
            <span className='main-title'>Early warnings</span>
            <div className='field-wrapper'>
                <div className='left'>
                    <span>show <input type="number" ref={rowNumber} value={sliceCount} min={1} onChange={(e) => handleSliceCountChange(e)} /> entries</span>
                </div>
                <div className='right'>
                    <span> search <input type="text" ref={searchText} onChange={(e) => handleSearchTextChange(e)} placeholder='Search here' /></span>
                </div>
            </div>
            <div className='table-body'>
                <div className='table-wrapper'>
                    <div className='table-row header' style={{ gridTemplateColumns: `4rem repeat(8, minmax(8rem, 1fr))`, width: '100%'}}>
                        <span>
                            <input type="checkbox" className='select-all-checkbox' onChange={(e) => handleSelectAllCheckbox(e)}/>
                        </span>
                        <span onClick={(e) => buildingIdSortHandle()}>
                            Building Id
                            <div>
                                {buildingIdSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => buildingTypeSortHandle()}>
                            Type
                            <div>
                                {buildingTypeSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => ownerSortHandle()}>
                            Owner
                            <div>
                                {ownerSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => mobileSortHandle()}>
                            Mobile
                            <div>
                                {mobileSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => riskAreaSortHandle()}>
                            Area of Risk
                            <div>
                                {riskAreaSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => maxDepthSortHandle()}>
                            Max Depth
                            <div>
                                {maxDepthSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => startSortHandle()}>
                            Start Time
                            <div>
                                {startSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                        <span onClick={(e) => peakSortHandle()}>
                            Peak Type
                            <div>
                                {peakSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                                
                            </div>
                        </span>
                    </div>
                </div>

                {props.isLoading ? (
                    <div className='loading-wrapper'>
                        <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
						<span>Searching user data...</span>
                    </div>
                ) : (
                    slicedData[selectedPage] && slicedData[selectedPage].map((row, index) => (
                        <div key={index} className='table-wrapper'>
                            <div className='table-row' style={{ gridTemplateColumns: `4rem repeat(8, minmax(8rem, 1fr))`, width: '100%'}}>
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <input type="checkbox" checked={selectedGroups.some(g => g.buildingId === row.buildingId)} onChange={(e) => handleGroupSelection(row, e.target.checked)}/>
                                </span>
                                <span>{row.buildingId}</span>
                                <span>{row.type}</span>
                                <span>{row.owner}</span>
                                <span>{row.mobile}</span>
                                <span>{row.areaOfRisk}</span>
                                <span>{row.maxDepth}</span>
                                <span>{row.startTime}</span>
                                <span>{row.peakTime}</span>
                            </div>
                        </div>
                    ))
                )}
            </div>
            
            {filteredData.length === 0 && (
                <div className='table-no-data-wrapper'>
                    <span>no any data available</span>
                </div>
            )}
            <div className='table-pagination-wrapper'>
                <div className='icon-page-box' style={{ marginBottom: "0.5rem" }} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                <div className='page-wrapper'>
                    {slicedData.map((page, index) => (
                        <span key={index} className={selectedPage === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPage(index)}>{index + 1}</span>
                    ))}
                </div>
                <div className='icon-page-box' style={{ marginBottom: "0.5rem" }} onClick={(e) => paginationNavigation("next")}>&gt;</div>
            </div>
        </div>
    )
}

export default FloodSimulationDataTable;